import { useAuth } from '@/contexts/auth-context';
import { useSalesPortalSignedInEmployeeQuery } from '@/experiences/sales-portal/blocs/documents/sales-portal-signed-in-employee.generated';

interface UseSalesPortalSignedInEmployeeLoaderResult {
  name: string | null;
  uuid: string | null;
}

/**
 * Loads the signed-in sales rep's display identity.
 *
 * Sales Portal renders outside the UserContextProvider, so the employee is
 * resolved from the AuthContext UUID instead of the user context.
 *
 * @returns The rep's name and UUID, or nulls while loading or when signed out.
 */
export const useSalesPortalSignedInEmployeeLoader =
  (): UseSalesPortalSignedInEmployeeLoaderResult => {
    const authenticatedUserUUID = useAuth((s) => s.authenticatedUserUUID);

    const { data } = useSalesPortalSignedInEmployeeQuery({
      skip: !authenticatedUserUUID,
      variables: { userUUID: authenticatedUserUUID! },
    });

    return {
      name: data?.employees_by_pk?.name ?? null,
      uuid: data?.employees_by_pk?.uuid ?? null,
    };
  };
